var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "transcript-summary-card rounded-sm pa-4 mb-3",
      class: { "transcript-summary-card--inverted": _vm.inverted }
    },
    [
      _vm.title || _vm.icon
        ? _c("div", { staticClass: "d-flex align-center mb-5" }, [
            _vm.icon
              ? _c(
                  "span",
                  { staticClass: "transcript-summary-card__icon mr-2" },
                  [
                    _c("icon-svg", {
                      attrs: {
                        name: _vm.icon,
                        size: "16",
                        color: "var(--white)"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.title
              ? _c("span", { staticClass: "table-new-ux-v1-title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }